/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ADDABLE EMAIL LIST : STYLES --------------- ++++++++++ */
export default theme => ({
    addableemaillist: {
        '& .add-new-email': {
            color: `#1494F4`,
            fontWeight: 500,
            fontSize: pxToEm(16),
            lineHeight: pxToEm(16),
            cursor: `pointer`
        },
        '& .addable-email-div': {
            display: `flex`,
            alignItems: `flex-start`,
            justifyContent: `space-between`,
            width: pxToEm(335),
            '& .remove': {
                marginTop: pxToEm(24),
                color: '#DF1D1D'
            }
        }
    }
});
